<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="xl"
      hide-footer
      footer-class="pt-0 border-0"
    >
      <template #modal-header="{ close }">
        <div class="modal-title">สินค้า</div>
        <button type="button" aria-label="Close" class="close" @click="close">
          ×
        </button>
      </template>
      <div class="bg-white border-red">
        <div class="d-block">
          <div class="">
            <b-row
              ><b-col cols="5" class="d-flex align-items-end">
                <InputText
                  v-model="filter.serial"
                  textFloat="Serial Number"
                  placeholder="ค้นหา Serial Number"
                  type="text"
                  name="search_product"
                  faIcon="search"
                  className=" my-2 flex-grow-1"
                  @onEnter="(val) => handleSearch(val)"
                  @onClickIcon="(val) => handleSearch(val)"
                />
                <div>
                  <img
                    src="@/assets/images/icons/bin.png"
                    alt="delete"
                    class="pointer ml-2 my-2"
                    center
                    width="32"
                    @click="handleSearch((filter.invoiceNo = ''))"
                  />
                </div>
              </b-col>
              <b-col cols="5" class="d-flex align-items-end">
                <InputText
                  v-model="filter.search"
                  textFloat="สินค้า"
                  placeholder="ค้นหาสินค้า"
                  type="text"
                  name="search_product"
                  faIcon="search"
                  className="my-2 flex-grow-1 "
                  @onEnter="(val) => handleSearch(val)"
                  @onClickIcon="(val) => handleSearch(val)"
                />
                <div>
                  <img
                    src="@/assets/images/icons/bin.png"
                    alt="delete"
                    class="pointer mb-2 ml-2"
                    center
                    width="32"
                    @click="handleSearch((filter.search = ''))"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col>
              <b-table
                responsive
                striped
                hover
                :fields="fields"
                :items="items"
                :busy="isBusy"
                show-empty
                empty-text="No matching records found"
                class="table-main"
                :no-border-collapse="false"
              >
                <template v-slot:cell(select)="data">
                  <b-button
                    variant="primary-color"
                    class="btn-modal btn-hover"
                    @click="selectRow(data.item)"
                    :disabled="isBusy"
                  >
                    เลือก
                  </b-button>
                </template>
                <template v-slot:cell(imageUrl)="{ item }">
                  <img
                    :src="item.imageUrl"
                    class="img-size"
                    v-if="item.imageUrl"
                  />
                  <img
                    v-else
                    src="@/assets/images/noimg.png"
                    alt="no-image-product"
                    class="img-size"
                  />
                </template>
                <template v-slot:cell(name)="data">
                  <b>{{ data.item.name || "-" }}</b>
                  <p>{{ data.item.category_name || "-" }}</p>
                </template>
                <template v-slot:cell(price)="data">
                  <div>
                    {{ data.item.price | numeral("0,0.00") }}
                  </div>
                </template>
                <template v-slot:cell(weight)="data">
                  <div>
                    {{ data.item.weight | numeral("0,0.00") }}
                  </div>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center text-black my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <Pagination
            @handleChangeTake="(val) => handleChangeTake(val, 'all')"
            :pageOptions="pageOptions"
            :filter="filter"
            :rows="rows"
            @pagination="(val) => pagination(val, 'all')"
          />
        </div>
      </div>
    </b-modal>
    <ModalNote ref="modalNote" :branchId="branchId" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import OtherLoading from "@/components/loading/OtherLoading";
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import ModalNote from "@/components/customer/ModalNote";
import HeaderPanel from "@/components/HeaderPanel";
import InputDatePickerFilter from "@/components/inputs/InputDatePickerFilter";

export default {
  components: {
    OtherLoading,
    Pagination,
    InputText,
    ModalNote,
    HeaderPanel,
    InputDatePickerFilter,
  },
  data() {
    return {
      isLoading: false,
      showModal: false,

      filter: {
        search: "",
        UserGUID: "",
        invoiceNo: "",
        serial: "",
        page: 1,
        take: 5,
      },

      items: [],
      isBusy: false,
      rows: 0,

      fields: [
        {
          key: "select",
          label: "",
        },
        {
          key: "imageUrl",
          label: "Image",
        },
        {
          key: "barcode",
          label: "รหัสสินค้า",
          id: 5,
        },
        {
          key: "name",
          label: "ชื่อสินค้า",
          tdClass: "text-left w-200",
          id: 1,
        },
        {
          key: "serial",
          label: "Serial",
        },
        {
          key: "weight",
          label: "น้ำหนัก",
          id: 8,
        },
      ],

      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      dateTimeFix: "getDateTimeFix",
      branchId: "getBranchId",
      userGuid: "getUserGuid",
    }),
  },

  methods: {
    async show(form, search) {
      this.filter.UserGUID = form.repair_owner_user_guid;
      this.filter.search = search;
      await this.getSearch();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    pagination(page) {
      this.filter.page = page;
      this.getSearch();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getSearch();
    },
    handleSearch(search) {
      //   this.filter.search = search;
      this.getSearch();
    },

    selectRow(item) {
      this.$emit("setSelectProduct", item);
      this.hide();
    },

    async getSearch() {
      await this.axios
        .post(`${this.$baseUrl}/repair/product/list`, this.filter)
        .then(async (data) => {
          if (data.result == 1) {
            await this.$store.dispatch("getDynamicFields", {
              products_id: data.detail.datas.map((el) => el.productId),
              body: data.detail.datas,
              serials_id: data.detail.datas.map(
                (el) => el.inventoryProductSerialId
              ),
              fields: this.fields,
              key_product_id: "productId",
              key_serial_id: "inventoryProductSerialId",
            });

            this.items = data.detail.datas;
            this.rows = data.detail.count;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}
::v-deep .modal-body {
  padding: 1rem 1rem;
}
.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}
::v-deep .nav-tabs li {
  border-left: 1px solid white;
  border-right: 1px solid white;
}
.credit-panel {
  background-color: var(--secondary-color);
  padding: 10px 10px;
  .total {
    font-size: 20px;
  }
}
::v-deep .table-credit {
  .table.b-table > thead > tr > th {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
}

.img-size {
  width: 60px;
  height: 60px;
}

// ::v-deep .table-main {
//   &:not(.table-credit) {
//     table {
//       min-height: 360px;
//     }
//   }
// }
</style>
